import { Box } from "@mui/material";

import { VideoFrame } from "@/types";

import { formatTime } from "../utils/time";

interface VideoScrubberFrameProps {
  frame: VideoFrame;
  position: number;
  onFrameMouseDown: (timestamp: number, event: React.MouseEvent) => void;
}

export const VideoScrubberFrame = (props: VideoScrubberFrameProps) => {
  const { frame, position, onFrameMouseDown } = props;

  return (
    <Box
      sx={{
        position: "absolute",
        left: `${10 + position}%`,
        top: "50%",
        width: 40,
        height: 40,
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
        borderRadius: 1,
        overflow: "hidden",
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        onFrameMouseDown(frame.timestamp, e);
      }}
    >
      <img
        src={frame.src}
        alt={`Frame at ${formatTime(frame.timestamp)}`}
        draggable={false}
        onDragStart={(e) => e.preventDefault()}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
        }}
      />
    </Box>
  );
};
